var ModifyPlanModalController = /** @class */ (function () {
    function ModifyPlanModalController() {
        // this.selectedPlanName = this.resolve.selectedPlanName;
        // this.planTypeList = this.resolve.planTypeList;
        // this.selectedPlan = this.resolve.selectedPlan;
        // this.futurePlan = this.resolve.futurePlan;
        // this.isModifyPlan = this.resolve.isModifyPlan;
        // this.isFuturePlanExists = this.resolve.isFuturePlanExists;
        // this.isActivePlanExists = this.resolve.isActivePlanExists;
        // this.currentPlanEndDate = this.resolve.currentPlanEndDate;
    }
    ModifyPlanModalController.prototype.$onInit = function () {
        this.selectedPlanName = this.resolve.selectedPlanName;
        this.planTypeList = this.resolve.planTypeList;
        this.selectedPlan = this.resolve.selectedPlan;
        this.futurePlan = this.resolve.futurePlan;
        this.isModifyPlan = this.resolve.isModifyPlan;
        this.isFuturePlanExists = this.resolve.isFuturePlanExists;
        this.isActivePlanExists = this.resolve.isActivePlanExists;
        this.currentPlanEndDate = this.resolve.currentPlanEndDate;
        this.callbackObject = { callbackType: 'cancel', entity: {} };
    };
    ModifyPlanModalController.prototype.savePlan = function () {
        this.callbackObject.callbackType = "save";
        this.closeModal();
    };
    ModifyPlanModalController.prototype.closeModal = function () {
        this.modalInstance.close(this.callbackObject);
    };
    ModifyPlanModalController.prototype.dismissModal = function () {
        this.modalInstance.dismiss('cancel');
    };
    return ModifyPlanModalController;
}());
// import * as TEMPLATE from './modify-plan-modal.html';
import * as TEMPLATE from 'raw-loader!./modify-plan-modal.html';
export var ModifyPlanModalComponent = {
    selector: 'modifyPlanModal',
    component: {
        bindings: {
            modalInstance: "<",
            resolve: "<"
        },
        controller: ModifyPlanModalController,
        template: TEMPLATE.default
        // templateUrl: 'app/partials/missioncontrol/company/modifyPlanModal/modify-plan-modal.html'
    }
};
//# sourceMappingURL=modify-plan-modal.component.js.map